import { lazy, Suspense } from 'react';
import { useConsent } from '@/hooks/useConsent';

const ConsentedWistiaPlayer = lazy(() => import('./ConsentedWistiaPlayer'));

interface WistiaVideoProps {
  mediaId: string;
  className?: string;
}

export default function WistiaVideo({ mediaId, className = '' }: WistiaVideoProps) {
  const { canUse } = useConsent();

  if (!canUse('functional')) {
    return <div className={`${className} aspect-video rounded-lg bg-neutral-100 dark:bg-neutral-900`} />;
  }

  return (
    <Suspense fallback={<div className={`${className} aspect-video rounded-lg bg-neutral-100 dark:bg-neutral-900`} />}>
      <ConsentedWistiaPlayer mediaId={mediaId} className={className} />
    </Suspense>
  );
}
